<template>
    <!-- 填空题 -->
    <div class="itemConte indexConte">
        <h5>{{itmData.questionindex}}.<span v-html="itmData.subject"></span>（{{itmData.questiontypename+'，'+itmData.quesscore}}分）</h5>
        <div class="resBox">
            <div class="flex res mt-10">
            </div>
        </div>
        <div class="resAns">
            <p>学员答案：{{itmData.uselanswer}}<span class="ans">答案{{itmData.answerstatus === 1 ? '正确':'错误'}}</span></p>
            <p>正确答案：{{ itmData | ansStr}}</p>
            <p v-if="itmData.quesanalysis" class="analysis">解析：<span v-html="itmData.quesanalysis"></span></p>
            <p v-else class="analysis">解析：暂无解析</p>
        </div>
    </div>
</template>
<script>
export default {
    props: ['itmData'],
    filters: {
        ansStr(ansData){
            let str = ''
            ansData.finalanswerblank.answerblank.forEach(itm => {
                str = str + itm
            })
            return str
        }
    },
    methods: {
        ansStr(ansData){
            let str = ''
            ansData.finalanswerblank.answerblank.forEach(itm => {
                str = str + itm
            })
            return str
        }
    }
}
</script>
<style lang="scss" scoped>
</style>